export class NewTicketRequest {
    code?: string;
    email?: string;
    crewCompany?: string;
    outboundFlight: FlightSegment[];
    inboundFlight: FlightSegment[];
}

export class FlightSegment {
    airlineCode: string;
    flightNumber: string;
    departureDateTime: string;
    arrivalDateTime: string;
    departureAirport: string;
    arrivalAirport: string;
}
